export const addOrder = (array) => {
  return array?.map((obj, i) => {
    return { ...obj, order: i + 1 };
  });
};
